/* StarzyCards theme runtime (no dependencies).
 * - quantity ladder + "Set Quantity" stepper + "Add N Cards" (both buy boxes on a page stay in sync)
 * - cart drawer: Ajax add / change through Shopify's Section Rendering API (the drawer HTML is Liquid)
 * - Frequently Bought Together ADD, header count
 * - sale countdown (only rendered with a real end date; hides itself at zero, never restarts)
 * - sticky add-to-cart, exit-intent popup (once per session), tabs */
(function () {
  'use strict';
  var Z = window.ZC || {};
  var R = Z.routes || { add: '/cart/add', change: '/cart/change', cart: '/cart' };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // ---------- money ----------
  function money(cents) {
    var fmt = Z.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    function grp(x, d, th, dec) { var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dec); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      return grp(n, 2, ',', '.');
    });
  }

  // ---------- buy boxes ----------
  function Box(root) {
    this.root = root;
    this.single = root.getAttribute('data-single') === '1';
    this.volume = root.getAttribute('data-volume') === '1';   // per-unit pricing: steps of 1, n x the rate of the biggest pack <= n
    this.base = +root.getAttribute('data-base') || 0;
    this.max = +root.getAttribute('data-max') || 100;
    this.tiers = $$('[data-tier]', root).filter(function (t) { return !t.hasAttribute('data-soldout'); }).map(function (t) {
      return { el: t, id: t.getAttribute('data-variant'), qty: +t.getAttribute('data-qty'), price: +t.getAttribute('data-price'), compare: +t.getAttribute('data-compare') };
    });
    this.idInput = $('[data-zc-id]', root);
    this.qtyInput = $('[data-zc-qty]', root);
    this.single_price = 0;
    var on = this.tiers.filter(function (t) { return t.el.classList.contains('is-on'); })[0] || this.tiers[0];
    this.n = on ? on.qty : 1;
    if (this.single) { this.single_price = this.base; }
    var self = this;
    this.tiers.forEach(function (t) {
      t.el.addEventListener('click', function () { self.set(t.qty, true); });
    });
    var ch = $('[data-zc-cheaper]', root);
    if (ch) ch.addEventListener('click', function () { self.set(+ch.getAttribute('data-n'), true); });
    $$('[data-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { self.step(+b.getAttribute('data-step')); });
    });
    var form = $('form', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.add(form); });
    this.render();
  }
  Box.prototype.steps = function () { return this.tiers.map(function (t) { return t.qty; }); };
  Box.prototype.step = function (dir) {
    if (this.single || this.volume) { this.set(Math.min(this.max, Math.max(1, this.n + dir)), true); return; }
    var s = this.steps(), top = s[s.length - 1], i = s.indexOf(this.n);
    var next;
    if (dir > 0) next = i >= 0 && i < s.length - 1 ? s[i + 1] : this.n + top;            // past the biggest pack: add another one
    else next = this.n > top ? this.n - top : (i > 0 ? s[i - 1] : s[0]);
    this.set(Math.min(Math.max(next, s[0]), Math.max(top, this.max - (this.max % top))), true);
  };
  // n = number of cards. Picks the pack whose size = n, else the biggest pack x quantity.
  Box.prototype.pick = function (n) {
    if (this.single) return { tier: null, qty: n };
    if (this.volume) {
      var at = this.tiers[0];
      this.tiers.forEach(function (t) { if (t.qty <= n) at = t; });
      return { tier: at, qty: n, volume: true };
    }
    var exact = this.tiers.filter(function (t) { return t.qty === n; })[0];
    if (exact) return { tier: exact, qty: 1 };
    var top = this.tiers[this.tiers.length - 1];
    return { tier: top, qty: Math.max(1, Math.round(n / top.qty)) };
  };
  Box.prototype.set = function (n, broadcast) {
    this.n = n; this.render();
    if (broadcast) document.dispatchEvent(new CustomEvent('zc:qty', { detail: { n: n, src: this } }));
  };
  Box.prototype.render = function () {
    var p = this.pick(this.n), r = this.root, unit = this.n === 1 ? r.getAttribute('data-unit') : r.getAttribute('data-units');
    var price, was;
    if (p.volume) {
      var unitT = this.tiers.filter(function (t) { return t.qty === 1; })[0] || p.tier;
      this.idInput.value = unitT.id; this.qtyInput.value = p.qty;
      price = Math.round(p.tier.price / p.tier.qty) * p.qty; was = Math.round(p.tier.compare / p.tier.qty * p.qty);
      this.tiers.forEach(function (t) { var on = t === p.tier; t.el.classList.toggle('is-on', on); var i = $('input', t.el); if (i) i.checked = on; });
    } else if (p.tier) {
      this.idInput.value = p.tier.id; this.qtyInput.value = p.qty;
      price = p.tier.price * p.qty; was = p.tier.compare * p.qty;
      this.tiers.forEach(function (t) { var on = t === p.tier; t.el.classList.toggle('is-on', on); var i = $('input', t.el); if (i) i.checked = on; });
    } else {
      this.qtyInput.value = p.qty; price = this.base * p.qty; was = price;
    }
    var per = Math.floor(price / this.n);
    var nEl = $('[data-zc-n]', r); if (nEl) nEl.textContent = this.n;
    var line = $('[data-zc-line]', r); if (line) line.textContent = this.n + ' × ' + money(per) + ' ' + (r.getAttribute('data-per-tpl') || '');
    var wasEl = $('[data-zc-was]', r); if (wasEl) { wasEl.textContent = money(was); wasEl.hidden = !(was > price); }
    var nowEl = $('[data-zc-now]', r); if (nowEl) nowEl.textContent = money(price);
    var ch = $('[data-zc-cheaper]', r);   // a bigger pack that costs no more than the current count (e.g. 14 cards vs the 15-pack)
    if (ch) {
      var nx = p.volume ? this.tiers.filter(function (t) { return t.qty > p.qty; })[0] : null;
      ch.hidden = !(nx && nx.price <= price);
      if (nx) { ch.setAttribute('data-n', nx.qty); ch.textContent = ch.getAttribute('data-tpl').replace('[n]', nx.qty).replace('[unit]', r.getAttribute('data-units')).replace('[price]', money(nx.price)); }
    }
    var add = $('[data-zc-add]', r);
    if (add) add.textContent = (r.getAttribute('data-add-tpl') || 'Add [n] [unit]').replace('[n]', this.n).replace('[unit]', unit);
  };
  Box.prototype.add = function (form) {
    var btn = $('[data-zc-add]', this.root);
    if (btn) btn.disabled = true;
    addItems([{ id: +this.idInput.value, quantity: +this.qtyInput.value }]).catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  };
  var boxes = $$('[data-zc-buy]').map(function (el) { return new Box(el); });
  document.addEventListener('zc:qty', function (e) { boxes.forEach(function (b) { if (b !== e.detail.src && !b.single) b.set(e.detail.n, false); }); });

  // ---------- cart drawer ----------
  function drawer() { return $('#zc-cart'); }
  function sectionId() { var d = drawer(); return d ? d.getAttribute('data-section-id') : null; }
  function openCart() { var d = drawer(); if (!d) { location.href = R.cart; return; } d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeCart() { var d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  function swap(sections) {
    var id = sectionId(); if (!id || !sections || !sections[id]) return;
    var tmp = document.createElement('div'); tmp.innerHTML = sections[id];
    var fresh = tmp.querySelector('#zc-cart'); var d = drawer();
    if (fresh && d) { var open = d.classList.contains('is-open'); d.replaceWith(fresh); if (open) fresh.classList.add('is-open'); }
    if (typeof window.ZC_SALE_FILL === 'function') window.ZC_SALE_FILL();   // running sale name (header Sale calendar) into the fresh drawer
    var units = fresh ? fresh.getAttribute('data-units') : null;
    $$('[data-cart-count]').forEach(function (c) { c.textContent = units; c.hidden = !(+units > 0); });
  }
  function post(url, body) {
    var id = sectionId(); if (id) { body.sections = [id]; body.sections_url = location.pathname; }
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  // ---------- dated gift (e.g. Black Friday: free stand with a 10+ card pack) ----------
  // Z.offer = { ends: ISO, qual: [variant ids that qualify], gift: variant id } from head-tags (only while settings.sale_ends_at is set).
  // The gift line carries the _zc_gift property; the price is zeroed by the store's automatic "buy X get Y" discount.
  function syncGift() {
    var o = Z.offer;
    if (!o || !o.gift || !o.qual || !o.qual.length || !(Date.parse(o.ends) > Date.now())) return Promise.resolve();
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var qual = items.some(function (i) { return o.qual.indexOf(i.variant_id) > -1 || (o.unit && i.variant_id === o.unit && i.quantity >= o.min); });
      var gi = -1;
      items.forEach(function (i, k) { if (gi < 0 && i.properties && i.properties._zc_gift) gi = k; });
      if (qual && gi < 0) return post(R.add, { items: [{ id: o.gift, quantity: 1, properties: { _zc_gift: '1' } }] }).then(function (res) { swap(res.sections); });
      if (!qual && gi > -1) return post(R.change, { line: gi + 1, quantity: 0 }).then(function (res) { swap(res.sections); });
      if (qual && gi > -1 && items[gi].quantity !== 1) return post(R.change, { line: gi + 1, quantity: 1 }).then(function (res) { swap(res.sections); });
    }).catch(function () {});
  }
  function addItems(items) { return post(R.add, { items: items }).then(function (res) { swap(res.sections); openCart(); return syncGift(); }); }
  // the $20 5-card add-on (cart drawer upsell) only stays in the cart next to the review card itself
  function syncAddon() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [], ai = -1, card = false;
      items.forEach(function (i, k) { if (i.handle === 'extra-5-review-cards') ai = k; else if (i.handle === 'google-review-card') card = true; });
      if (ai > -1 && !card) return post(R.change, { line: ai + 1, quantity: 0 }).then(function (res) { swap(res.sections); });
      if (ai > -1 && items[ai].quantity > 1) return post(R.change, { line: ai + 1, quantity: 1 }).then(function (res) { swap(res.sections); });
    }).catch(function () {});
  }
  function change(line, qty) { return post(R.change, { line: line, quantity: qty }).then(function (res) { swap(res.sections); return syncGift(); }).then(syncAddon); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var openBtn = t.closest('[data-cart-open]'); if (openBtn && drawer()) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    var ln = t.closest('#zc-cart [data-line]'); if (ln) { change(+ln.getAttribute('data-line'), +ln.getAttribute('data-qty')); return; }
    var fbt = t.closest('[data-fbt-add]'); if (fbt) { fbt.disabled = true; addItems([{ id: +fbt.getAttribute('data-fbt-add'), quantity: 1 }]); return; }
  });
  document.addEventListener('change', function (e) { // opt-in shipping protection (never pre-ticked)
    var c = e.target && e.target.closest ? e.target.closest('[data-zc-prot]') : null; if (!c) return;
    c.disabled = true;
    if (c.checked) addItems([{ id: +c.getAttribute('data-variant'), quantity: 1 }]);
    else if (+c.getAttribute('data-prot-line') > 0) change(+c.getAttribute('data-prot-line'), 0);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); hidePopup(); } });

  // ---------- countdown (real end date only) ----------
  $$('[data-countdown]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-ends'));
    if (!end) { el.hidden = true; return; }
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; $$('[data-sale-dated]').forEach(function (d) { d.hidden = true; }); clearInterval(timer); return; }
      $('[data-h]', el).textContent = pad(Math.floor(s / 3600)); $('[data-m]', el).textContent = pad(Math.floor(s / 60) % 60); $('[data-s]', el).textContent = pad(s % 60);
    }
    var timer = setInterval(tick, 1000); tick();
  });
  $$('[data-sale-dated]').forEach(function (d) { var end = Date.parse(d.getAttribute('data-ends')); if (!end || end <= Date.now()) d.hidden = true; });

  // ---------- sticky add to cart ----------
  var sticky = $('[data-zc-sticky]');
  if (sticky && boxes.length && 'IntersectionObserver' in window) {
    var main = boxes[0].root;
    new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting || en[0].boundingClientRect.top > 0; }).observe(main);
    $('[data-zc-sticky-add]', sticky).addEventListener('click', function () { var f = $('form', main); if (f.requestSubmit) f.requestSubmit(); else boxes[0].add(f); });
  } else if (sticky && !boxes.length) {
    var b = $('[data-zc-sticky-add]', sticky); sticky.hidden = false;
    b.addEventListener('click', function () { if (Z.cardUrl) location.href = Z.cardUrl; });
  }

  // ---------- card activation (404 page at /t/<code>; Shopify Flow turns the tagged customer into the URL redirect) ----------
  // Only links that open Google's write-a-review box (stars) are accepted:
  //   g.page/r/<id>/review  (Business Profile > Ask for reviews)   ·   search.google.com/local/writereview?placeid=<id>
  function actUrl(v) {
    var m = /^\s*(https?:\/\/[^\s,]+)\s*$/i.exec(v || ''); if (!m) return '';
    var u; try { u = new URL(m[1]); } catch (e) { return ''; }
    var h = u.hostname.toLowerCase(), r = /^\/r\/([A-Za-z0-9_-]+)(\/review)?\/?$/.exec(u.pathname);
    if (h === 'g.page' && r) return 'https://g.page/r/' + r[1] + '/review';
    if (h === 'search.google.com' && u.pathname === '/local/writereview' && /^[A-Za-z0-9_-]{10,}$/.test(u.searchParams.get('placeid') || ''))
      return 'https://search.google.com/local/writereview?placeid=' + u.searchParams.get('placeid');
    return '';
  }
  $$('[data-zc-act]').forEach(function (box) {
    var code = box.getAttribute('data-code'); if (!code) return; // set by the inline script on /t/<code> 404s
    var form = $('form', box); if (!form) return;
    $$('[data-zc-act-code]', box).forEach(function (el) { el.textContent = code; });
    if (/[?&]customer_posted=true/.test(location.search) || location.hash === '#contact_form' && /customer_posted/.test(location.href)) {
      form.hidden = true; var done = $('[data-zc-act-done]', box); if (done) done.hidden = false;
      // reload the bare card URL until Shopify serves the new redirect (the review box)
      var tries = 0, t = setInterval(function () { if (++tries > 10) return clearInterval(t); location.replace(location.pathname); }, 4000);
      return;
    }
    $('[data-zc-act-email]', box).value = 'act-' + code.toLowerCase() + '-' + Date.now() + '@starzycards.com';
    form.addEventListener('submit', function (e) {
      var url = actUrl(($('[data-zc-act-url]', box) || {}).value), owner = (($('[data-zc-act-owner]', box) || {}).value || '').trim().replace(/,/g, '');
      var bad = $('[data-zc-act-bad]', box), tags = $('[data-zc-act-tags]', box);
      if (!url) { e.preventDefault(); if (bad) bad.hidden = false; return; }
      if (bad) bad.hidden = true;
      tags.value = 'zc-act,zc-card:' + code + ',zc-url:' + url + (owner ? ',zc-owner:' + owner : '');
    });
  });

  // ---------- free-stand tag on qualifying packs: hide once the dated offer has ended (pages can be cached) ----------
  if (!(Z.offer && Date.parse(Z.offer.ends) > Date.now())) $$('[data-zc-gifttag]').forEach(function (el) { el.hidden = true; });

  // ---------- exit-intent popup ----------
  var pop = $('[data-zc-exit]'), KEY = 'zc_exit_seen';
  function seen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function mark() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function showPopup() { if (!pop || seen() || (drawer() && drawer().classList.contains('is-open'))) return; pop.hidden = false; mark(); }
  function hidePopup() { if (pop) pop.hidden = true; }
  if (pop) {
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) showPopup(); });
    var delay = +pop.getAttribute('data-delay');
    if (delay > 0 && window.matchMedia && window.matchMedia('(hover: none)').matches) setTimeout(showPopup, delay * 1000);
    $$('[data-zc-exit-no]', pop).forEach(function (b) { b.addEventListener('click', hidePopup); });
    var yes = $('[data-zc-exit-yes]', pop);
    if (yes) yes.addEventListener('click', function () { hidePopup(); });
  }

  // ---------- tabs ----------
  $$('[data-zc-tabs]').forEach(function (box) {
    var btns = $$('[data-tab]', box), panels = $$('[data-panel]', box);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-tab');
        btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
      });
    });
  });

  window.ZC = Object.assign(Z, { money: money, openCart: openCart, closeCart: closeCart, boxes: boxes });
})();
